import { availableLocales } from '$lib/i18n';
import type { ParamMatcher } from '@sveltejs/kit';

export const match = (param => {
    const regex = new RegExp(`^(${availableLocales.join('|')})$`, 'i');
    return regex.test(param);
}) satisfies ParamMatcher;
